import { RequiredIndicator } from '@shared/ui/form-label-indicators'
import { FlexBox, FormError, FormField, FormInputGroup, FormLabel, TextInput } from '@vp/swan'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { ContactDetailsFields } from '../../../hooks/use-contact-details'

const NAME_PATTERN = /^[\p{L}\d\s'-]+$/u

const nameValidation = (errorKey: string) => (v: string) => {
  const trimmed = v.trim()
  if (!trimmed) return false
  if (!NAME_PATTERN.test(trimmed)) return errorKey
  return true
}

interface NameFieldsProps {
  control: Control<ContactDetailsFields>
}

export const NameFields = ({ control }: NameFieldsProps) => {
  const { t } = useTranslation()

  return (
    <FlexBox gap={{ xs: 0, sm: 6 }} flexDirection={{ xs: 'column', sm: 'row' }}>
      <FormField data-testid="first-name-field" style={{ flex: 1 }}>
        <Controller
          name="firstName"
          control={control}
          rules={{
            required: true,
            validate: nameValidation('contact_us.page.steps.details.fields.first_name_error_special_chars'),
          }}
          render={({ field, fieldState }) => (
            <>
              <FormLabel>
                {t('contact_us.page.steps.details.fields.first_name_label')}
                <RequiredIndicator />
              </FormLabel>
              <FormInputGroup>
                <TextInput data-testid="first-name-input" {...field} />
                {fieldState.error?.message && <FormError data-testid="first-name-error">{t(fieldState.error.message)}</FormError>}
              </FormInputGroup>
            </>
          )}
        />
      </FormField>

      <FormField data-testid="last-name-field" style={{ flex: 1 }}>
        <Controller
          name="lastName"
          control={control}
          rules={{
            required: true,
            validate: nameValidation('contact_us.page.steps.details.fields.last_name_error_special_chars'),
          }}
          render={({ field, fieldState }) => (
            <>
              <FormLabel>
                {t('contact_us.page.steps.details.fields.last_name_label')}
                <RequiredIndicator />
              </FormLabel>
              <FormInputGroup>
                <TextInput data-testid="last-name-input" {...field} />
                {fieldState.error?.message && <FormError data-testid="last-name-error">{t(fieldState.error.message)}</FormError>}
              </FormInputGroup>
            </>
          )}
        />
      </FormField>
    </FlexBox>
  )
}
